import { PerspectiveCamera, Raycaster, Vector2, WebGLRenderer } from "three";
import { Scene1 } from "./scene/Scene1.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import Stats from "three/examples/jsm/libs/stats.module";
import Emitter from "../helpers/emitters";
import { moveMenu, selectView360, selectView360Modal } from "../helpers/selectImageView360.js";
import { GuiHelper } from "./helpers/GuiHelper.js";

export class App {
	constructor(container) {
		this.container = container;
		this.scene = new Scene1();
		//* Camara
		this.camera = new PerspectiveCamera(60, this.container.clientWidth / this.container.clientHeight, 1, 1100);
		this.camera.position.set(-0.036, 0.362, -0.932);
		this.camera.lookAt(0, 0, 0);
		//* Renderer's config
		this.renderer = new WebGLRenderer({
			antialias: true,
		});
		this.raycaster = new Raycaster();
		this.INTERSECTED = null;
		this.pointer = new Vector2();
		this.renderer.setPixelRatio(window.devicePixelRatio);
		this.container.appendChild(this.renderer.domElement);
		this.dragAndDrop = 0;
		//* methods
		// this.statusFps();
		// this.helpers();
		this.#emmitterRayCaster();
		this.camareController();
		this.onResize();
		this.render();
	}

	camareController() {
		this.controls = new OrbitControls(this.camera, this.renderer.domElement);
		this.controls.enableDamping = true;
		this.controls.dampingFactor = 0.07;
		this.controls.minDistance = 1;
		this.controls.maxDistance = 1;
		this.controls.maxPolarAngle = Math.PI / 1.5;
		this.controls.minPolarAngle = Math.PI / 4;
	}

	helpers() {
		const helpGui = new GuiHelper();
		helpGui.objectsPosition(this.camera, "camare");
	}

	statusFps() {
		this.stats = new Stats();
		document.body.appendChild(this.stats.domElement);
	}

	onResize() {
		this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
		this.camera.aspect = this.container.clientWidth / this.container.clientHeight;
		this.camera.updateProjectionMatrix();
	}

	#emmitterRayCaster() {
		Emitter.on("dragAndDrop", (data) => {
			//* click se mueve si esta moviendo
			this.dragAndDrop = 0;
		});
		Emitter.on("raycasterMouseMove", (data) => {
			//* click se mueve si esta moviendo
			this.dragAndDrop += 1;
			this.onPointerRayCaster(data);
			// move raycaster
			this.onMoveRayCaster();
		});
		Emitter.on("raycaster", (data) => {
			//* click 0
			this.onPointerRayCaster(data);
			if (this.dragAndDrop < 15) {
				// update raycaster
				this.onUpdateSpheraTexture();
			}
		});
		Emitter.on("modalInformationMove", (name) => {
			this.onMoveInformationModal(name);
		});
		Emitter.on("clearPlanes", (menu = 0) => {
			if (menu === 2) {
				this.camera.position.set(-0.036, 0.362, -0.932);
			}
		});
	}

	onPointerRayCaster(event) {
		this.pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
		this.pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
	}

	onMoveRayCaster() {
		this.raycaster.setFromCamera(this.pointer, this.camera);
		const intersects = this.raycaster.intersectObjects(this.scene.groupPlanes.children, false);
		if (intersects.length > 0) {
			if (!intersects[0].object.name.startsWith("move")) {
				if (intersects[0].object.visible) {
					if (this.INTERSECTED !== intersects[0].object) {
						if (this.INTERSECTED) {
							Emitter.emit("cleanHover", this.INTERSECTED.name);
						}
						this.INTERSECTED = intersects[0].object;
						Emitter.emit("hoverHotSpot", intersects[0].object.name);
					}
				}
			}
		} else {
			if (this.INTERSECTED) {
				Emitter.emit("cleanHover", this.INTERSECTED.name);
			}
			this.INTERSECTED = null;
		}
	}

	onUpdateSpheraTexture() {
		this.raycaster.setFromCamera(this.pointer, this.camera);
		const intersects = this.raycaster.intersectObjects(this.scene.groupPlanes.children, false);
		// Emitter.emit("logstest", intersects);
		if (intersects.length > 0) {
			for (let i = 0; i < intersects.length; i++) {
				const element = intersects[i];
				if (element.object.name.startsWith("move")) {
					if (element.object.visible) {
						// console.log("---- ");
						// console.log(element.object.name, element);
						const { status, camarePosition, ...select } = selectView360(this.scene.hotSpotArrow, element.object.name);
						if (status === 0) {
							// camarePosition
							this.camera.position.set(camarePosition.x, camarePosition.y, camarePosition.z);
							Emitter.emit("hotspotArrow", select);
						}
					}
				} else {
					const { status, name } = moveMenu(element.object.name);
					if (status === 0) {
						Emitter.emit("movelocation", name);
					}
				}
			}
		}
	}

	onMoveInformationModal(name) {
		const { status, camarePosition, ...select } = selectView360Modal(this.scene.hotSpotArrow, name);
		if (status === 0) {
			this.camera.position.set(camarePosition.x, camarePosition.y, camarePosition.z);
			Emitter.emit("hotspotArrow", select);
		}
	}

	render() {
		// render
		this.renderer.render(this.scene, this.camera);
		// Updates here
		this.scene.update(this.camera);
		// controlls
		this.controls.update();
		// stats update
		// this.stats.update();
		// loop render
		this.renderer.setAnimationLoop(() => this.render());
	}
}
